<template>
  <div>
    <div :class="`map-set ${controlMap ? '' : 'disable_swipe disabled'} `">
      <img class="point disable_swipe" :src="point" />
      <l-map
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer :url="url" :attribution="attribution"> </l-tile-layer>
      </l-map>
    </div>

    <!-- <button class="btn btn-sm mb-4" @click="controlMap=!controlMap"><span v-if="controlMap">Убрать управление</span><span v-else>Управлять картой</span></button> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { latLng, Icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LPolyline,
  LIcon,
} from "vue2-leaflet";

import "leaflet/dist/leaflet.css";
export default {
  computed: {
    ...mapState(["lastUpdate"]),
    center: {
      get() {
        return latLng(
          this.defaultLat ? this.defaultLat : 41.311081,
          this.defaultLon ? this.defaultLon : 69.240562
        );
      },
      set() {},
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LPolyline,
    LIcon,
  },
  name: "products",
  props: {
    disableOnline: {
      default: false,
    },
    defaultLat: {
      default: 41.311081,
    },
    defaultLon: {
      default: 69.240562,
    },
  },
  mounted() {
    if (this.defaultLat && this.defaultLon)
      this.$emit("input", { lat: this.defaultLat, lon: this.defaultLon });
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.$emit("input", { lat: center.lat, lon: center.lng });
    },
  },
  data() {
    return {
      controlMap: true,
      point: require("@/assets/img/place.png"),
      zoom: 18,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: "",
      currentZoom: 15.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: false,
      },
      showMap: true,
    };
  },
};
</script>
<style lang="scss">
.map-set {
  .point {
    z-index: 1;
    position: absolute;
    width: 30px;
    height: auto;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin-top: -16px;
  }

  overflow: hidden;
  position: relative;
  height: 0;
  padding-top: 50%;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 10px;
  z-index: 1;
  & .vue2leaflet-map {
    z-index: 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
